import { createAction } from '@reduxjs/toolkit'

export const restoreFromStorage = createAction<{isRestore: boolean}>('app/restoreFromStorage');
export const enterPageFirstRefresh = createAction<{isFirstRefresh: boolean}>('app/enterPageFirstRefresh');
export const selectedAsset = createAction<{asset: any}>('app/selectedAsset');
export const selectedCollection = createAction<{collection: any}>('app/selectedCollection');
export const shareC = createAction<{share: object}>('app/shareC');

